/**
 * Attempts to determine the environment an app is being run in by looking at the
 * domain name of it.
 * 
 * @param {string} domainName - The domain name to attempt to extract the environment from.
 * @returns {string}
 */
export function getEnv( domainName ) {
    // Validate the parameter.
    if ( !domainName || typeof domainName !== 'string' || domainName.length <= 1 ) {
        return Environment.UNKNOWN;
    }

    // Check to see if we are in the PROD environment before checking for the other
    // environments since the URL for PROD is unique.
    if ( domainName.includes( 'hoyavisionlearningcenter' ) ) {
        return Environment.PROD;
    }

    // Grab the first token in the provided domain name (seperated by '.') and check
    // to see if that matches any known environments we have set up.
    const potentialEnv = domainName.toLowerCase().split( '.' )[ 0 ];
    switch ( potentialEnv ) {
        case Environment.LOCAL: {
            return Environment.LOCAL;
        }
        case Environment.QA: {
            return Environment.QA;
        }
        case Environment.PPRD: {
            return Environment.PPRD;
        }
        case Environment.PROD: {
            return Environment.PROD;
        }
        default: {
            console.warn( `Unexpected domain name '${ domainName }'` );
            return Environment.UNKNOWN;
        }
    }
}

/**
 * Represents the environment types that exist for this project.
 * 
 * @enum
 */
export const Environment = {
    UNKNOWN: 'unknown',
    LOCAL: 'localhost',
    QA: 'qa',
    PPRD: 'pprd',
    PROD: 'prod',
};
